import "./Wine.module.css";
import Header from "@/reusable_sections/Header";
import Eurocontrol from "./sections/Eurocontrol";
import PremiumContentShowcase from "./sections/PremiumContentShowcase";
import Coating from "./sections/Coating";
import Solutions from "./sections/Solutions";
import Footer from "@/reusable_sections/Footer";
export default function WinePage() {
  return <div>
      <Header />
      
      <Eurocontrol />
      <PremiumContentShowcase />
      <Coating />
      <Solutions />
      <Footer />
    </div>;
}